import { AmmunitionStockEventService } from '../model/ammunition-stock-event.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { AmmunitionStockEvent } from 'assets-model';
import { Observable } from 'rxjs';


export class AmmunitionStockEventDataSource extends CrudDataSource<AmmunitionStockEvent> {

  constructor(private service: AmmunitionStockEventService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<AmmunitionStockEvent>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


